import React from 'react';
import { RegularPriceRow } from './regular';
import { usePriceRowContext } from '../../price-row-context';
import { useDispatch } from 'react-redux';
import {
  productPriceClick,
  productClickOutBounce,
} from 'src/areas/product/actions/product';
import { IPriceRow } from '../types';
import { ProductPriceClickStatus } from 'src/areas/product/actions/types';
import { trackProductSizeVariantClickout } from '../../../tracking';
import { useOfferListFilterContext } from 'src/areas/product/components/offer-list-filter-context';
import { FilterType } from 'src/components/price-list/types';
import {
  TrackClickScope,
  trackOfferClickWithRevenue,
} from 'src/globals/tracking/conversion';
import { useProductContext } from '../../../product-context';
import { getDistinctVariantValues } from '../../../product-variants/utils';

export const PriceRow: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<IPriceRow>
>> = props => {
  const { item, index, className, isInPrimaryList } = props;
  const { productId } = usePriceRowContext();
  const { allOffersWithActiveAdditives } = useProductContext();
  const variantValues = getDistinctVariantValues(allOffersWithActiveAdditives);
  const { getFilter } = useOfferListFilterContext();
  const isVariantFiltered = Boolean(getFilter(FilterType.VARIANT_SIZE)?.active);
  const rowKey = `${item.id}-${index}`;
  const dispatch = useDispatch();

  return (
    <RegularPriceRow
      key={rowKey}
      onClickOutBounce={() => {
        dispatch(productClickOutBounce(productId, item.id));
      }}
      onPriceClick={(
        featured: boolean,
        status: ProductPriceClickStatus,
        isAlternative: boolean
      ) => {
        // NOTE: Any changes done to data or structure of PRODUCT_PRICE_CLICK needs to be
        // reflected in react/middlewares/out pre click for tracking clicks before JS bundle
        dispatch(
          productPriceClick(productId, item, featured, status, isAlternative)
        );

        trackOfferClickWithRevenue({
          scope: isAlternative
            ? TrackClickScope.PRICE_LIST_EXPANDED
            : TrackClickScope.PRICE_LIST,
          offerId: item.id!,
          productId,
        });

        if (item) {
          if (variantValues?.sizes?.length) {
            trackProductSizeVariantClickout({
              isVariantFiltered,
              isPrimaryList: Boolean(isInPrimaryList),
            });
          }
        }
      }}
      className={className}
    />
  );
};
